/**
 * Created by sung on 2017-02-07.
 */
import {NgModule, Component, OnInit} from '@angular/core';
import {PanelModule,DataTableModule,ButtonModule,InputTextModule,DropdownModule} from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {SelectItem} from "primeng/components/common/api";
import {MamAdminService} from "../../service/mam_service.component";
import { SettingProperty } from '../../model/setting_property';
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS


@Component({
  selector:'system-setting',
  templateUrl:'system_setting.html'
})
export class SystemSettingComponent implements OnInit {

  ngOnInit() {
    this.getConfigInfo();

  }

  private setting_list : SettingProperty[] = [];
  warningItems : SelectItem[] =[];
  greaterItems : SelectItem[] =[];

  selectedGreater : string;

  addForm : FormGroup;

  dbmsWarnLimitsize_Item : SelectItem[] =[];
  dbmsCriticalLimitsize_item : SelectItem[] =[];
  adminAccessIPEnabled_item : SelectItem[] =[];
  isCompressDvc_item : SelectItem[] =[];
  encodeDvc_item : SelectItem[] =[];
  deviceRegistrationCnt_item : SelectItem[] =[];
  passwordFailureMax_item : SelectItem[] =[];


  selected_dbmsCriticalLimitsize : string;
  selected_dbmsWarnLimitsize : string;
  selected_adminAccessIPEnabled : boolean;
  selected_isCompressDvc : string;
  selected_encodeDvc : boolean;
  selected_deviceRegistrationCnt : number;
  selected_passwordFailureMax : number;

  translate : TranslateServiceForm;
  constructor(private service : MamAdminService, private fb:FormBuilder, private logger : Logger, private _translate : TranslateServiceForm){
    this.translate = _translate;
    this.dbmsWarnLimitsize_Item = [
      {label : '85',value : '85'},
      {label : '90',value : '90'},
      {label : '95',value : '95'}
    ];

    this.dbmsCriticalLimitsize_item = [
      {label : '90',value : '90'},
      {label : '95',value : '95'}
    ];

    this.adminAccessIPEnabled_item = [
      {label : 'true', value : true},
      {label : 'false', value : false}
    ];

    this.encodeDvc_item = [
      {label : 'true', value : true},
      {label : 'false', value : false}
    ];

    this.isCompressDvc_item = [
      {label : 'true', value : true},
      {label : 'false', value : false}
    ];

    this.deviceRegistrationCnt_item = [
      {label : '0', value : 0},
      {label : '1', value : 1},
      {label : '2', value : 2},
      {label : '3', value : 3},
      {label : '4', value : 4},
      {label : '5', value : 5}
    ];

    this.passwordFailureMax_item = [
      {label : '1', value : 1},
      {label : '2', value : 2},
      {label : '3', value : 3},
      {label : '4', value : 4},
      {label : '5', value : 5}
    ];





    this.addForm = this.fb.group({
      'sessionMaxInactiveInterval' : new FormControl(''),
      'systemEmail' : new FormControl(''),
      'securityEnabled' : new FormControl(''),
      'scepUrl' : new FormControl(''),
      'reConnectDeviceMaximum' : new FormControl(''),
      'passwordMinLength' : new FormControl(''),
      'passwordMaxLength' : new FormControl(''),
      'passwordFailureMax' : new FormControl(''),
      'passwordCombine' : new FormControl(''),
      'passwordChangePeriod' : new FormControl(''),
      'maxSessionCnt' : new FormControl(''),
      'licenseCode' : new FormControl(''),
      'isUseVisitor' : new FormControl(''),
      'isCompressDvc' : new FormControl(''),
      'encodeDvc' : new FormControl(''),
      'deviceRegistrationCnt' : new FormControl(''),
      'deviceMaximumInactiveTime' : new FormControl(''),
      'dbmsWarnLimitsize' : new FormControl(''),
      'dbmsCriticalLimitsize' : new FormControl(''),
      'clientTimeoutSec' : new FormControl(''),
      'adminAccessIPEnabled' : new FormControl(''),
      'adminAccessIP4' : new FormControl(''),
      'adminAccessIP3' : new FormControl(''),
      'adminAccessIP2' : new FormControl(''),
      'adminAccessIP1' : new FormControl(''),
    });
  }

  getConfigInfo() {
    this.service.getConfigInfo(1,20).subscribe(
        value => {
            this.setting_list = value.rows;
            this.logger.debug("-- setting_list : " , value);
        },
        error=>{ this.logger.error("-- error : " + error); },
        ()=>{
          if(this.setting_list.length > 0 ) {
              this.setting_list.forEach(setting=> {
                if(setting.name == 'adminAccessIPEnabled' || setting.name == 'isCompressDvc' || setting.name == 'encodeDvc'){
                    var value = setting.propertyValue=='true'?true:false;
                    this.addForm.controls[setting.name].setValue(value);
                }else{
                    this.addForm.controls[setting.name].setValue(setting.propertyValue);
                }
                this.logger.debug("setting name :" , setting.name);
              })
          }

          this.selected_dbmsWarnLimitsize = this.addForm.controls['dbmsWarnLimitsize'].value;
          //this.addForm.controls['adminAccessIPEnabled'].setValue(false);

        }
    )
  }

  updateAll(ids:string, values:string) {
    this.service.updateAll(ids, values).subscribe(
        value => {
            let result = value;
            this.logger.debug("-- updateAll : " , result);
            alert(this.translate.instant('MESSAGE_Setting_Complete'));
        },
        error=>{ this.logger.error("-- error : " + error); },
        ()=>{}
    )
  }

  onSubmit(data) {
    this.logger.debug("data", data);
    if(this.addForm.controls['sessionMaxInactiveInterval'].value <300){
      alert(this.translate.instant('MESSAGE_SessionValue_lessThan300'));
      return;
    }

    if(this.addForm.controls['adminAccessIPEnabled'].value == true) {
      if(!this.addForm.controls['adminAccessIP1'].value) {
        alert(this.translate.instant('MESSAGE_Enter_Allowable_IP'));
        return;
      }
    }

    let min = this.addForm.controls['passwordMinLength'].value;
    let max = this.addForm.controls['passwordMaxLength'].value;
    if( Number(min) > Number(max) ) {
      alert(this.translate.instant('MESSAGE_Maximum_PasswordLength_LessThan_Minimum_PasswordLength'));
      return;
    }
    this.logger.debug("form Dat :" , data);
    let ids = "";
    let values = "";
    this.setting_list.forEach(setting=> {
      if(!ids) ids = String(setting.id);
      else ids = ids + "||" + setting.id;

      if(!values) values = String(this.addForm.controls[setting.name].value)
      else values = values + "||" + String(this.addForm.controls[setting.name].value);
    })

    this.logger.debug("ids :", ids);
    this.logger.debug("values :", values);

    this.updateAll(ids, values);
  }

  get diagnostic() { return JSON.stringify(this.addForm.value);}

}

@NgModule({
  imports:[ReactiveFormsModule, PanelModule,DataTableModule,ButtonModule,InputTextModule, CommonModule,BrowserModule,HttpModule, FormsModule,DropdownModule, TranslatePipeMoudle],
  declarations:[SystemSettingComponent],
  exports:[SystemSettingComponent],
  providers:[]
})
export class SystemSettingModule{

}



// WEBPACK FOOTER //
// ./src/app/page/system/system_setting.ts